
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"24","cy":"24","r":"23.5","fill":"#fff","stroke":"#000"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.964 16.361c-.373 0-.675.3-.675.672v7.838h15.422v-7.838a.673.673 0 00-.675-.672H16.964zM32.07 26.566H15.93l-1.697 2.927c-.553.954.138 2.146 1.245 2.146h17.044c1.107 0 1.798-1.192 1.245-2.146l-1.697-2.927zm-17.483-1.074v-8.46a2.371 2.371 0 012.377-2.365h14.072a2.371 2.371 0 012.377 2.366v8.459l1.829 3.154c1.208 2.084-.303 4.687-2.72 4.687H15.478c-2.417 0-3.928-2.603-2.72-4.687l1.829-3.154zm6.865 3.658a.85.85 0 01.851-.847h3.394c.47 0 .852.379.852.847a.85.85 0 01-.852.847h-3.394a.85.85 0 01-.851-.847z","fill":"#202D38"}})])
          )
        }
      }
    